import React from "react";
import {Box, VisuallyHidden} from "@unibuddy/patron";
import {MessageRow, MessageBubbleDesktop} from "@unibuddy/chat-ui";
import styled, {keyframes} from "styled-components";

const pulse = keyframes`   
  0% {
    transform: scale(1) translateY(0);
  }
  30% {
    transform: scale(1.5) translateY(-2px);
  }
  60% {
    transform: scale(1) translateY(0);
  }
  100% {
    transform: scale(1) translateY(0);
  }
`;

const Dot = styled.span`
    border-radius: 100%;
    border: 4px solid ${({theme}) => theme.colors.grey600};
    margin: 4px;
`;

const Dot1 = styled(Dot)`
    animation: ${pulse} 1.5s ease-in-out infinite;
    margin-left: 0;
`;

const Dot2 = styled(Dot)`
    animation: ${pulse} 1.5s ease-in-out 0.25s infinite;
`;

const Dot3 = styled(Dot)`
    animation: ${pulse} 1.5s ease-in-out 0.5s infinite;
    margin-right: 0;
`;

const DotContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 26px;
`;

export function ChatMessageTypingBubble() {
    return (
        <Box paddingX="xsmall" role="listitem">
            <MessageRow align="left" position="top">
                <MessageBubbleDesktop align="left" position="top">
                    <DotContainer data-testid="dot-container">
                        <Dot1 />
                        <Dot2 />
                        <Dot3 />
                    </DotContainer>
                    <VisuallyHidden>Assistant is thinking...</VisuallyHidden>
                </MessageBubbleDesktop>
            </MessageRow>
        </Box>
    );
}
